import courses from '../../../../utils/API/BackendHelper/sme/courses';
import * as types from './_actionTypes';

const initialState = {
  notifications: [],
  colleges: [],
  courses : [],
  loading: false,
  sending: false,
  error: null
};

const smeNotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_NOTIFICATIONS_REQUEST:
    case types.FETCH_COLLEGES_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload,
        error: null
      };
    
    case types.FETCH_COLLEGES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        colleges: action.payload,
        error: null
      };
    
    case types.FETCH_NOTIFICATIONS_FAILURE:
    case types.FETCH_COLLEGES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    

      case types.FETCH_COURSES_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

      case types.FETCH_COURSES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        courses: action.payload,
        error: null
      };
      case types.FETCH_COURSES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case types.SEND_NOTIFICATION_REQUEST:
      return {
        ...state,
        sending: true,
        error: null
      };
    
    case types.SEND_NOTIFICATION_SUCCESS:
      return {
        ...state,
        sending: false,
        notifications: [action.payload, ...state.notifications],
        error: null
      };
    
    case types.SEND_NOTIFICATION_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.payload
      };
    
    case types.DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.id !== action.payload)
      };
    
    case types.DELETE_NOTIFICATION_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default smeNotificationsReducer;